import Loading from '../loading';
import { StyledCard, Footer } from './styles';

const Panel = ({ icon, title, actions, footer, loading, children, dv, ...props }) => {
  return (
    <StyledCard
      {...props}
      title={
        (icon || title) && (
          <>
            {icon}
            {title}
          </>
        )
      }
    >
      <div style={{ padding: 24, display: dv }}>{loading ? <Loading padding={0} size="default" /> : children}</div>
      {footer && <Footer>{footer}</Footer>}
    </StyledCard>
  );
};

export default Panel;
